import LockIcon from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/lock/LockIcon';
import {Tooltip} from '@mintdata/mint-kit/impl/components/tooltip/Tooltip';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./LockEditor.less');
const cx = classnames.bind(styles);

interface LockComponentProps
{
    value:boolean,
    className?:string,
    tooltip?:string;
    onClick:(e:React.SyntheticEvent<any>) => void,
}

export const LockComponent = (props:LockComponentProps) =>
{
    const button = (
        <button
            onClick={props.onClick}
            className={cx(styles.base, {
                [props.className]: !!props.className,
            })}
        >
            <LockIcon
                className={styles.lockIcon}
                isLocked={props.value}
            />
        </button>
    );

    return props.tooltip
        ? <Tooltip
            content={props.tooltip}
            targetClassName={cx('tooltip')}
            popoverProps={{
                className: cx('tooltipPopover'),
                ignoreEsc: true,
            }}
        >
            {button}
        </Tooltip>
        : button;
};
